import { actions } from './action'

const initialState = {
  notifications: null,
}

const notificationsReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_NOTIFICATIONS':
      return {
        ...state,
        notifications: action.payload,
      }
    case actions.FETCH_NOTIFICATIONS:
      return {
        ...state,
        notifications: action.payload,
      }
    default:
      return state
  }
}
export default notificationsReducer
